<script setup>
import ProjekteList from "./components/ProjekteList.vue";
</script>

<template>
    <ProjekteList />
</template>

<script>
export default {
  components: {
    ProjekteList,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>
